export const SALES_ORDER_DOCUMENT_DROP_DOWN_ITEMS = [
    {
        id: "sales-orders",
        text: "Sales order"
    },
    {
        id: "invoices",
        text: "Invoice"
    },
    {
        id: "receipts",
        text: "Receipt"
    },
    {
        id: "picks",
        text: "Pick list"
    },
    {
        id: "packing-slips",
        text: "Packing slip"
    },
    {
        id: "box-labels",
        text: "Box label"
    }
]